import { render } from "./InboxList.vue?vue&type=template&id=dea36862"
import script from "./InboxList.vue?vue&type=script&lang=js"
export * from "./InboxList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__